export default {
  NEUTRAL: 'NEUTRAL',
  FIRE: 'FIRE',
  WATER: 'WATER',
  WIND: 'WIND',
};
